import { toast } from "react-toastify"
import api from "./api"

export const getEntrysFromFitBank = async () =>{
    let taxNumber = localStorage.getItem('taxNumber')
    let accountId = localStorage.getItem('accountId')

        let response = await api.post(`/entrys/updateFromFitBank`, {
            taxNumber,
            accountId
        })
        console.log("response.data ", response.data.data);
        console.log("response.data ", response.data.ok);
        if(response.data.ok){
            return response.data.data
        }else{
            toast.error('Não foi possivel carregar os Extratos')
            return ''
        }

}